import { FC } from 'react';
import { Link } from 'react-router-dom-v5-compat';

import { ConnectionNode, PlatformConfigType } from 'dashboard/models/platform-node';
import { assertNever } from 'lib/utils/types';

export const routeToNode = (node: ConnectionNode) => {
  if (node['permission-blocked']) return;

  switch (node.type) {
    case PlatformConfigType.AccountType:
      return `/dashboard/account-types/${node.token}`;
    case PlatformConfigType.CaseTemplate:
      return `/dashboard/case-templates/${node.token}`;
    case PlatformConfigType.InquiryTemplate:
      // doesn't support template level route yet
      return `/dashboard/inquiry-templates/${node.token}/${node.metadata['version-token']}/flow`;
    case PlatformConfigType.InquiryTemplateVersion:
      return `/dashboard/inquiry-templates/${node.metadata['inquiry-template-token']}/${node.token}/flow`;
    case PlatformConfigType.List:
      return `/dashboard/lists/${node.token}`;
    case PlatformConfigType.ReportTemplate:
      return `/dashboard/report-templates/${node.token}`;
    case PlatformConfigType.ReportTemplateVersion:
      return `/dashboard/report-templates/${node.metadata['report-template-token']}`;
    case PlatformConfigType.TxnType:
      return `/dashboard/transaction-types/${node.token}`;
    case PlatformConfigType.VerificationTemplate:
      // doesn't support template level route yet
      return `/dashboard/verification-templates/${node.token}/${node.metadata['version-token']}`;
    case PlatformConfigType.VerificationTemplateVersion:
      // only renders for inquiry template verifications
      return node.metadata['inquiry-template-token']
        ? `/dashboard/inquiry-templates/${node.metadata['inquiry-template-token']}/\
${node.metadata['inquiry-template-version-token']}/config/verifications/${node.token}`
        : `/dashboard/verification-templates/${node.metadata['verification-template-token']}/${node.token}`;
    case PlatformConfigType.Workflow:
      return `/dashboard/workflows/${node.token}`;
    case PlatformConfigType.WorkflowVersion:
      return `/dashboard/workflows/${node.metadata['workflow-token']}/${node.token}`;
    default:
      assertNever(node);
  }
};

export const PlatformNodeLink: FC<{ node: ConnectionNode }> = ({ node }) => {
  const linkToNode = routeToNode(node);
  return linkToNode ? (
    <Link to={linkToNode}>{node.metadata?.name}</Link>
  ) : (
    <>{node.metadata?.name}</>
  );
};
